import { Button, Tooltip } from 'antd';
import { RiArrowUpLine } from 'react-icons/ri';
import ScrollToTop from "react-scroll-up";

export default function ScrollTop() {
    return (
        <div className="scroll-to-top">
            <ScrollToTop showUnder={300} style={{ bottom: "6%" }}>
                <Tooltip title="Scroll To Top">
                    <Button type="primary" shape="circle" icon={<RiArrowUpLine />} className="hp-primary-shadow" style={{ width: 36, height: 36, fontSize: 16 }} />
                </Tooltip>
            </ScrollToTop>
        </div>
    );
};